var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99998 20H15.9998C17.1028 20 17.9998 19.103 17.9998 18V9.00011C18 8.86878 17.9741 8.73871 17.9239 8.61738C17.8736 8.49605 17.7998 8.38586 17.7068 8.29312L9.7069 0.293198C9.61412 0.200253 9.50391 0.126516 9.3826 0.076206C9.26129 0.0258958 9.13124 0 8.99991 0C8.86858 0 8.73854 0.0258958 8.61722 0.076206C8.49591 0.126516 8.3857 0.200253 8.29292 0.293198L0.292998 8.29312C0.2 8.38586 0.126243 8.49605 0.0759609 8.61738C0.0256793 8.73871 -0.000135139 8.86878 5.32011e-07 9.00011V18C5.32011e-07 19.103 0.896991 20 1.99998 20ZM6.99993 18V13.0001H10.9999V18H6.99993ZM1.99998 9.41411L8.99991 2.41418L15.9998 9.41411L16.0008 18H12.9999V13.0001C12.9999 11.8971 12.1029 11.0001 10.9999 11.0001H6.99993C5.89694 11.0001 4.99995 11.8971 4.99995 13.0001V18H1.99998V9.41411Z",
    fill: "#9097A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.44a4c8d8ff430b7e4fe65928fefbe97e.svg";
export { ForwardRef as ReactComponent };